import React, {Component} from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import TableComp from '../../../../components/_utils/table'

import moment from 'moment'
import ListFollowUps from '../../../../components/_utils/listFollowUp'

import { Button, Card, Col, notification, Row, Select, Tooltip} from 'antd'
import Request from '../../../../request'
import Settings from '../../../../components/_utils/settings'
import lodash from 'lodash'
import {connect} from 'react-redux'
import styles from './styles.less'
import common from '../../../common.less'

let counsellingData = {}
let studentObj = {}

const Option = Select.Option

let userCheckBox = {}

class AllInquiry extends Component {

    state = {
        count: 0,
        showFollowUp: false,
        studentId: null,
        allDesks: Settings.allDesks,
        deskNameObj: Settings.deskNameObj,
        deskId: '',
        counsellorId: '',
        allCounsellor: [],
        allBranches: [],
        deleteLoading: false,
        branchId: '',
        deskColor: null,
        userCheckBox: {},
        showSMS: false,
        showEmail: false,
        ratingArr: ['Fit2Apply', 'Potential', 'Neutral', 'Cold', 'Dead', 'Active'],
        modeArr: [
            "Conopy",
            "Education Fair",
            "Facebook",
            "Google",
            "Instagram",
            "Justdial",
            "Newspaper",
            "Personal",
            "Seminar",
            "School/College Event",
            "Telephone",
            "Website",
            "Whatsapp",
          ],
        inquiryArr: ['COACHING', 'STUDENT'],
        countryArr: [],
        drawer: false,
        drawerParam: null,
        isFollowUpOverdue: false,

    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showSMS: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({showSMS: false})
    }

    closeEmail = () => {
        this.setState({showEmail: false})
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({showEmail: true})
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    deleteStudent = async (_id) => {
        this.setState({deleteLoading: true})
        let x = await Request.deleteStudent({_id: _id, atLevel: 'Deleted'})
        this.setState({deleteLoading: false})
        if (x && !x.error) {
            notification.success({
                message: 'Deleted Successfully'
            })
            this.table.current.reload()
        } else {
            notification.error({message: 'Try again'})
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.followUpsCallback = this.followUpsCallback.bind(this);
    }

    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            _id: record._id
        }
        this.setState({showFollowUp: true})
    }
    renderStatus = (val) => {

        if (val === 'Super Hot') {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>
        }
        if (val === 'Fit2Apply') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Neutral') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
        if (val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            if (this.state.deskId) {
                params.atLevel = this.state.deskId
                params.page = 1
            }
            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }

            if (this.state.branchId) {
                params.studentBranchId = this.state.branchId
                params.page = 1
            }
            if (this.state.singleRatingFilter) {
                params['counsellingDesk.rating'] = this.state.singleRatingFilter
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: stringToDate.setHours(0, 0, 0),
                    $lt: stringToDate.setHours(23, 59, 59),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.isFollowUpOverdue) {
              params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            let data = await Request.getAllStudentListForUplaodingDocuments({
                ...params,
                regExFilters: ['studentName', 'watsupp', 'mobile']
            })

            delete data.error
            delete data.type
            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({count: data.total, allBranches: data.allBranches, userCheckBox: userCheckBox})
            resolve(data)
        })
    }

    closeFollowUp = () => {
        this.setState({showFollowUp: false})
    }
    returnDeskName = (val) => {
        const deskConfig = Settings.allDesks

        let findIn = lodash.find(deskConfig, (rr) => {
            return rr.name == val
        })

        if (findIn) {
            return <div style={{
                backgroundColor: findIn.color,
                color: 'white',
                padding: 3,
                display: 'inline-block',
                fontWeight: 'bold'
            }}>{Settings.deskNameObj[val]}</div>
        } else {
            return <div>{val}</div>
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({userCheckBox: cloneUserCheckBox})
    }

    followUpExtendedDate = (followUp) => {
        if(followUp && followUp.followUpDate){
          return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
      }

    componentWillMount() {
        let searchParams = new URLSearchParams(this.props.search)

        let singleRatingFilter = searchParams.get('rating')
        if (singleRatingFilter) {
            this.setState({singleRatingFilter: singleRatingFilter})
        }
    }

    async componentDidMount() {
        let { data: allCounsellor } = await Request.loadCounsellorListForStudentRights({
            results: 10000,
          })
          this.setState({
            allCounsellor
          })
    }

    loadCountry(callback) {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    let temp = []
                    lodash.each(resp.data, (vv) => {
                        temp.push({
                            text: vv.countryName,
                            value: vv.countryName
                        })
                    })
                    return callback(temp)

                } else {
                    return callback([])
                }
            })
            .catch(err => {
                return callback([])
            })
    }

    followUpsCallback(isFollowUpOverdue){
        this.setState({
          isFollowUpOverdue: isFollowUpOverdue,
        }, ()=> {
          this.table.current.reload()
        });
    }

    render() {
        const {
            allDesks,
            inquiryArr,
            allCounsellor = [],
            allBranches = [],
            deskColor,
            ratingArr,
            modeArr,
            deskNameObj
        } = this.state


        const columns = [
            {
                title: 'Action ',
                key: 'operation',
                dataindex: 'operation',
                width: 100,
                render: (text, record) => (
                    <React.Fragment>
                        <Tooltip title="Click To Edit Details">
                            <Button
                                className={styles.btn}
                                shape="circle"
                                size={"small"}
                                target={'blank'}
                                href={'/documents?id='+record._id}
                                icon="edit"
                            />
                        </Tooltip>
                        <span>
              </span>
                    </React.Fragment>
                )
            },
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <div
                                className={
                                this.followUpExtendedDate(record.followUp ? record.followUp : '')? styles.followUpExtendedDate : ''
                                }
                            >
                            <Tooltip>
                                <a className={styles.btn} target={'_blank'}
                                   href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{item}</a>
                            </Tooltip>
                            </div>
                        </React.Fragment>

                    )
                }
            },
            {
                title: 'Inquiry Type',
                key: 'selectInquiryType',
                dataIndex: 'selectInquiryType',
                filters: inquiryArr && inquiryArr.map(x => ({value: x, text: x}))
            },

            {
                title: 'At Stage',
                key: 'atLevel',
                dataIndex: 'atLevel',
                width: 150,
                sorter: true,
                render: (val, record) => {
                    return (
                        this.returnDeskName(val)
                    )
                }
            },
            {
                title: 'DOB',
                width: 100,
                sorter: true,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchTextName: 'D-M-Y(05-05-1997)',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Mode',
                key: 'mode',
                filters: modeArr && modeArr.map(x => ({value: x, text: x}))
            },
            {
                title: 'Rating',
                key: 'counsellingDesk.rating',
                filters: ratingArr && ratingArr.map(x => ({value: x, text: x})),
                render: (val, record) => {
                    return this.renderStatus(val)

                }
            },
            {
                title: 'Counsellor',
                key: 'counsellorId',
                filters: allCounsellor.map(x => ({value: x._id, text: x.name})),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Preference',
                key: 'preference',
                searchTextName: 'preference',
                filterRegex: true,
                render: (val, row) => {
                    return row.totalPreference ? (
                        <ul className={common.ul}>
                            {row.totalPreference.map((val, inde) => {
                                return <li key={inde}>{val.country}</li>
                            })}
                        </ul>
                    ) : null
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            }
        ]
        return (
            <PageHeaderWrapper title={` STUDENTS LIST : ${this.state.count} `} followUpsCallback={this.followUpsCallback}>
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp}/>
                ) : null}

                <Card style={{marginBottom: 10}}>
                    <div className={styles.filterBlock}>
                        <div style={{display: 'flex'}}>
                            <h5 className="search_title" style={{paddingTop: 8}}>
                                SEARCH BY DESK
                            </h5>
                            <Select
                                allowClear
                                style={{
                                    width: 214,
                                    paddingRight: 16,
                                    paddingLeft: 9,
                                    color: deskColor

                                }}
                                value={deskNameObj[this.state.deskId]}
                                placeholder="Select Desk"
                                onChange={deskId => {
                                    if (deskId) {
                                        deskId = JSON.parse(deskId)
                                        this.setState({
                                            deskId: deskId && deskId.name.toString(),
                                            deskColor: deskId.color
                                        }, () => {
                                            this.table.current.reload()
                                        })
                                    } else {
                                        this.setState({deskId: '', deskColor: ''}, () => {
                                            this.table.current.reload()
                                        })
                                    }
                                }}
                            >
                                {allDesks.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={JSON.stringify(val)}>
                                            <Row>
                                                <Col span={20}> {deskNameObj[val.name]} </Col>
                                                <Col span={4}>
                                                    <div style={{paddingTop: 10, backgroundColor: val.color}}></div>
                                                </Col>
                                            </Row>
                                        </Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div>

                </Card>

                <Card bordered={true}>
                    <TableComp
                        id={'allstudents'}
                        showSelector={true}
                        columns={columns}
                        ref={this.table}
                        apiRequest={params => this.apiRequest(params, columns)}
                        extraProps={{scroll: {x: 1800}}}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search

})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllInquiry)
